/* eslint-disable no-unused-vars */
import React, { useEffect, useContext } from 'react'

import AOS from 'aos';
import 'aos/dist/aos.css';

import Navbar from '../landingpage/sections/Navbar';
import HeroSection from '../landingpage/sections/HeroSection';
import ProductCarousel from '../landingpage/sections/ProductCarousel';
import EventsSection from '../landingpage/sections/Events/index';
import FeaturesSection from '../landingpage/sections/FeaturesSection';
import Footer from '../landingpage/sections/Footer/index.jsx';

const HomePage = () => {

    // const { isAuthenticated } = useContext(AuthContext);

    AOS.init();
    useEffect(() => {
        AOS.init({
            duration: 1000,
        });
    }, []);
    const handleScroll = () => {
        AOS.refresh();
    };

    return (
        <div className='main-wrapper'>

            {/* <Header /> */}
            <Navbar />
            <HeroSection />
            <ProductCarousel />
            <EventsSection />
            <FeaturesSection />
            <Footer />

        </div>
    )
}

export default HomePage;
